export default "__VITE_ASSET__Bdlsf6xd__"